import {module} from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: 'onChange'
        }
    }

    onChange(e) {
        const option = this.el.querySelector('option[value="'+ this.el.value +'"]')
        window.location.href=option.dataset.href
    }
}
